const alertGhost: object = {
  "blue-gray": {
    backgroud: "bg-blue-gray-500/20",
    color: "text-blue-gray-900",
  },
  gray: {
    backgroud: "bg-gray-500/20",
    color: "text-gray-900",
  },
  brown: {
    backgroud: "bg-brown-500/20",
    color: "text-brown-900",
  },
  "deep-orange": {
    backgroud: "bg-deep-orange-500/20",
    color: "text-deep-orange-900",
  },
  orange: {
    backgroud: "bg-orange-500/20",
    color: "text-orange-900",
  },
  amber: {
    backgroud: "bg-amber-500/20",
    color: "text-amber-900",
  },
  yellow: {
    backgroud: "bg-yellow-500/20",
    color: "text-yellow-900",
  },
  lime: {
    backgroud: "bg-lime-500/20",
    color: "text-lime-900",
  },
  "light-green": {
    backgroud: "bg-light-green-500/20",
    color: "text-light-green-900",
  },
  green: {
    backgroud: "bg-green-500/20",
    color: "text-green-900",
  },
  teal: {
    backgroud: "bg-teal-500/20",
    color: "text-teal-900",
  },
  cyan: {
    backgroud: "bg-cyan-500/20",
    color: "text-cyan-900",
  },
  "light-blue": {
    backgroud: "bg-light-blue-500/20",
    color: "text-light-blue-900",
  },
  blue: {
    backgroud: "bg-blue-500/20",
    color: "text-blue-900",
  },
  indigo: {
    backgroud: "bg-indigo-500/20",
    color: "text-indigo-900",
  },
  "deep-purple": {
    backgroud: "bg-deep-purple-500/20",
    color: "text-deep-purple-900",
  },
  purple: {
    backgroud: "bg-purple-500/20",
    color: "text-purple-900",
  },
  pink: {
    backgroud: "bg-pink-500/20",
    color: "text-pink-900",
  },
  red: {
    backgroud: "bg-red-500/20",
    color: "text-red-900",
  },
};

export default alertGhost;
